module.exports = __webpack_public_path__ + "img/organigram-comment.473e8301.svg";